"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const iterate_1 = require("./iterate");
exports.iterate = iterate_1.iterate;
exports.zip = iterate_1.zip;
exports.default = iterate_1.iterate;
//# sourceMappingURL=index.js.map